/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.inbox.MaximegalonType
*/
export var MaximegalonType;
(function (MaximegalonType) {
    MaximegalonType["APPROVAL"] = "APPROVAL";
    MaximegalonType["DECISION"] = "DECISION";
    MaximegalonType["FEEDBACK"] = "FEEDBACK";
    MaximegalonType["ORDERING"] = "ORDERING";
    MaximegalonType["STRUCTURE_EDIT"] = "STRUCTURE_EDIT";
    MaximegalonType["OUTPUT_TEXT"] = "OUTPUT_TEXT";
    MaximegalonType["OUTPUT_IMAGE"] = "OUTPUT_IMAGE";
    MaximegalonType["OUTPUT_DOCUMENT"] = "OUTPUT_DOCUMENT";
})(MaximegalonType || (MaximegalonType = {}));
//# sourceMappingURL=MaximegalonType.js.map